import styled from 'styled-components'

export const Wrapper = styled.div`
  align-items: center;
  display: flex;
  text-align: center;
  flex-direction: column;
`

export const Subtitle = styled.span`
  font-size: 18px;
  font-weight: var(--font-medium);
  margin-bottom: 15px;
`
